import React, { useState } from "react";
import PropTypes from "prop-types";

import DeleteKeywordModal from "../modals/DeleteKeywordModal";

import {
  Toolbar,
  Typography,
  Button,
  Switch,
  Box,
  FormControlLabel,
} from "@mui/material";

import { hasPermission } from "../../../../lib/components/form/RestrictedComponent";
import schema from "../../../../routes/permissions/schema";

const KeywordsTableToolbar = ({
  selected,
  setSelected,
  actions,
  updateKeywordState,
  setKeywordRequestBody,
  keywordRequestBody,
  emitSnack,
}) => {
  const { page, rowsPerPage, listEvents } = keywordRequestBody;

  const numSelected = selected.length;

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const canDelete = hasPermission(schema.MANAGE_CLIENT_KEYWORDS.DELETE);

  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);

  const handleDeleteKeywords = () => {
    const singularOrPlural = selected.length > 1 ? "s" : "";

    toggleDeleteModal(); // ideally this would toggle only after the requests are successful and in place display a loading button in the modal

    const promises = selected.map((id) => {
      return new Promise((resolve, reject) => {
        actions.delete({ keywordID: id }, (err, res) =>
          err ? reject(err) : resolve(res)
        );
      });
    });

    Promise.all(promises)
      .then(() => {
        emitSnack({
          type: "success",
          message: `Keyword${singularOrPlural} Deleted `,
        });
        updateKeywordState(page, rowsPerPage, listEvents, "delete", selected.length);
        setSelected([]);
      })
      .catch(() =>
        emitSnack({
          type: "error",
          message: `Couldn't Delete Keyword${singularOrPlural}`,
        })
      );
  };

  const handleListEventsChange = () => {
    setKeywordRequestBody({ ...keywordRequestBody, listEvents: !listEvents });

    updateKeywordState(undefined, undefined, !listEvents, "listEvents");
  };

  return (
    <>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          w: "auto",
        }}
      >
        <Box display="flex" alignItems="center">
          <Typography variant="h4">Keywords</Typography>
          <FormControlLabel
            control={
              <Switch
                sx={{ ml: 3 }}
                color="primary"
                checked={listEvents}
                onChange={handleListEventsChange}
              />
            }
            label="List Events"
            labelPlacement="end"
          />
        </Box>

        {canDelete && numSelected > 0 && (
          <Button onClick={toggleDeleteModal} color="error" variant="outlined">
            {`Delete ${numSelected === 1 ? "Keyword" : "Keywords"}`}
          </Button>
        )}
      </Toolbar>

      <DeleteKeywordModal
        open={deleteModalOpen}
        handleClose={toggleDeleteModal}
        handleConfirm={handleDeleteKeywords}
        numSelected={numSelected}
      />
    </>
  );
};

KeywordsTableToolbar.propTypes = {
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  updateKeywordState: PropTypes.func.isRequired,
  setKeywordRequestBody: PropTypes.func.isRequired,
  keywordRequestBody: PropTypes.object.isRequired,
  emitSnack: PropTypes.func.isRequired,
};

export default KeywordsTableToolbar;
